<template>
    <div>
        <nav-bar class="z-index"></nav-bar>

        <!--banner-->
        <div class="row autumn pt-10">
            <div class="col-12 ">
                <div
                        v-if="bannerfall !== null && bannerfall !== undefined && bannerfall.length > 0"
                        class="row"
                >
                    <carousel
                            :autoplay="true"
                            :dots="false"
                            :items="1"
                            :loop="false"
                            :margin="5"
                            :nav="false"
                            dir="ltr"
                            class="col-12 pt-0">
                        <div
                                v-for="(item,i) in bannerfall"
                                :key="i">
                            <v-img
                                    :alt="item.name"
                                    :src="getImgUrl(item.src)" class="">
                                <h2 class="banner-title font-30 bold white--text secondary-bg rounded p-1">{{
                                    item.text
                                    }}</h2>
                                <h2 class="banner-title2 font-30 bold white--text secondary-bg rounded p-1">
                                    {{ item.text1 }}</h2>
                            </v-img>
                        </div>
                    </carousel>
                </div>
            </div>
        </div>

        <div class="row winter pt-10">
            <div class="col-12 ">
                <div
                        v-if="bannerwinter !== null && bannerwinter !== undefined && bannerwinter.length > 0"
                        class="row"
                >
                    <carousel
                            :autoplay="true"
                            :dots="false"
                            :items="1"
                            :loop="false"
                            :margin="5"
                            :nav="false"
                            dir="ltr"
                            class="col-12 pt-0">
                        <div
                                v-for="(item,i) in bannerwinter"
                                :key="i">
                            <v-img
                                    :alt="item.name"
                                    :src="getImgUrl(item.src)" class="">
                                <h2 class="banner-title font-30 bold white--text secondary-bg rounded p-1 px-2">
                                    {{ item.text }}</h2>
                                <h2 class="banner-title2 font-30 bold white--text secondary-bg rounded p-1 px-2">
                                    {{ item.text1 }}</h2>
                            </v-img>
                        </div>
                    </carousel>
                </div>
            </div>
        </div>

        <div class="row spring pt-10">
            <div class="col-12 ">
                <div
                        v-if="bannerspring !== null && bannerspring !== undefined && bannerspring.length > 0"
                        class="row"
                >
                    <carousel
                            :autoplay="true"
                            :dots="false"
                            :items="1"
                            :loop="false"
                            :margin="5"
                            :nav="false"
                            dir="ltr"
                            class="col-12 pt-0">
                        <div
                                v-for="(item,i) in bannerspring"
                                :key="i">
                            <v-img
                                    :alt="item.name"
                                    :src="getImgUrl(item.src)" class="height-banner">
                                <h2 class="banner-title font-30 bold white--text secondary-bg rounded p-1 px-2">
                                    {{ item.text }}</h2>
                                <h2 class="banner-title2 font-30 bold white--text secondary-bg rounded p-1 px-2">
                                    {{ item.text1 }}</h2>
                            </v-img>
                        </div>
                    </carousel>
                </div>
            </div>
        </div>

        <div class="row summer pt-10">
            <div class="col-12 ">
                <div
                        v-if="bannersummer !== null && bannersummer !== undefined && bannersummer.length > 0"
                        class="row"
                >
                    <carousel
                            :autoplay="true"
                            :dots="false"
                            :items="1"
                            :loop="false"
                            :margin="5"
                            :nav="false"
                            dir="ltr"
                            class="col-12 pt-0">
                        <div
                                v-for="(item,i) in bannersummer"
                                :key="i">
                            <v-img
                                    :alt="item.name"
                                    :src="getImgUrl(item.src)" class="">
                                <h2 class="banner-title font-30 bold white--text secondary-bg rounded p-1 px-2">
                                    {{ item.text }}</h2>
                                <h2 class="banner-title2 font-30 bold white--text secondary-bg rounded p-1 px-2">
                                    {{ item.text1 }}</h2>
                            </v-img>
                        </div>
                    </carousel>
                </div>
            </div>
        </div>

        <card-slide class=""></card-slide>

        <!--چرا ایزیسیس-->
        <div class="container ">
            <div class="row">
                <div class="col-12 text-center">
                    <h1 class="h3 secondary-text">طراحی وب سایت اپلیکیشن موبایل و استارت اپ</h1>
                    <v-divider></v-divider>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="col-10 mx-auto">
                        <img
                                :alt="imageSeason.circle"
                                src="../assets/img/technology-webing.png"
                                class="filter mx-auto img-fluid d-none d-lg-block rotate relative fadeIn">
                        <img
                                :alt="imageSeason.circle"
                                src="../assets/img/technology-webing.png"
                                class="filter mx-auto img-fluid d-block d-lg-none rotate fadeIn relative position-img">

                        <div class="autumn">
                            <img
                                    :alt="imageSeason.NameImageAutumn"
                                    src="../assets/img/autumm.png"
                                    class="mx-auto img-fluid margin-img d-none d-lg-block absolute position-img fadeIn">
                            <img
                                    :alt="imageSeason.NameImageAutumn"
                                    src="../assets/img/autumm.png"
                                    class="mx-auto img-fluid margin-img-phone d-block d-lg-none fadeIn absolute position-img "
                            >

                        </div>

                        <div class="winter">
                            <img
                                    :alt="imageSeason.NameImageWinter"
                                    src="../assets/img/winter-1.png"
                                    class="mx-auto img-fluid margin-img d-none d-lg-block absolute position-img fadeIn ">
                            <img
                                    :alt="imageSeason.NameImageWinter"
                                    src="../assets/img/winter-1.png"
                                    class="mx-auto img-fluid margin-img-phone d-block d-lg-none fadeIn absolute position-img ">

                        </div>

                        <div class="spring">
                            <img
                                    :alt="imageSeason.NameImageWinterSpring"
                                    src="../assets/img/spring.png"
                                    class="mx-auto img-fluid margin-img d-none d-lg-block absolute position-img fadeIn ">
                            <img
                                    :alt="imageSeason.NameImageSpring"
                                    src="../assets/img/spring.png"
                                    class="mx-auto img-fluid margin-img-phone d-block d-lg-none fadeIn absolute position-img ">
                        </div>

                        <div class="summer">
                            <img
                                    :alt="imageSeason.NameImageSummer"
                                    src="../assets/img/summer-img.png"
                                    class="mx-auto img-fluid margin-img d-none d-lg-block absolute position-img fadeIn ">
                            <img
                                    :alt="imageSeason.NameImageSummer"
                                    src="../assets/img/summer-img.png"
                                    class="mx-auto img-fluid margin-img-phone d-block d-lg-none fadeIn absolute position-img ">

                        </div>

                    </div>
                </div>
                <div class="col-12 col-lg-6 text-left">
                    <div class="col-11 mx-auto">
                        <h2 class="secondary-text downtoup  text-align font-30">
                            {{ $getText("HOME_PAGE_SUPPORT_LIST_TITLE") }}
                        </h2>
                        <p class="downtoup text-align font-14">
                            {{ $getText("HOME_PAGE_SUPPORT_LIST_DESC1") }}
                        </p>
                    </div>
                    <div class="col-10 mx-auto downtoup text-align">
                        <div class="row ">
                            <div class="col-2">
                                <i class="fa-light fa-users-medical font-40 secondary-text righttoleft "></i>
                            </div>
                            <div class="col-10 ">
                                <h4 class="secondary-text font-16 bold righttoleft pb-2 text-align">
                                    {{ $getText("HOME_PAGE_SUPPORT_LIST_title2") }}
                                </h4>
                                <p class="righttoleft text-align font-14">
                                    {{ $getText("HOME_PAGE_SUPPORT_LIST_DESC2") }}
                                </p>
                            </div>
                            <div class="col-2">
                                <i class="fa-light fa-laptop-mobile font-40 secondary-text righttoleft"></i>
                            </div>
                            <div class="col-10">
                                <h4 class="secondary-text font-16 bold righttoleft pb-2 text-align">
                                    {{ $getText("HOME_PAGE_SUPPORT_LIST_title3") }}
                                </h4>
                                <p class="righttoleft text-align font-14">
                                    {{ $getText("HOME_PAGE_SUPPORT_LIST_DESC3") }}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--   سایر خدمات -->
        <v-img
                :alt="imageSeason.imageservice"
                class="bg-service"
                src="../assets/img/hand-bg.jpg">
            <service-card class=""></service-card>
        </v-img>


        <!--مدارک-->
        <div class="container-fluid py-9">
            <div class="text-center secondary-text font-28 pt-5 uptodown ">
                <i class="fal fa-medal fa-rotate-180 font-60 "></i>
            </div>
            <h2 class="text-center secondary-text bold pt-5 uptodown font-30">
                {{ $getText("CERTIFICATE") }}
            </h2>

            <div
                    v-if="Certificate !== null && Certificate !== undefined && Certificate.length > 0"
                    class="container "
                    dir="ltr">
                <carousel
                        :autoplay="true"
                        :dots="true"
                        :loop="false"
                        :margin="50"
                        :nav="false"
                        :responsive="{0:{items:1,nav:false},500:{items:2,nav:false},1000:{items:3,nav:false}}"
                        :rtl="false">
                    <v-card
                            v-for="item in Certificate"
                            :key="item.id" class="">
                        <div class="lefttoright">
                            <div class="cursor">
                                <img
                                        :alt="(item.alt)"
                                        :src="getImgUrl(item.src)" class="mx-auto certificate-border"
                                        @click="openCertificateDialog(item.srcDialog , item.alt)">
                                <div class="certificate">
                                    <h3 class="font-18 text-center p-3 fontnum bold ">
                                        {{ item.name }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </carousel>
            </div>
            <div
                    v-if="Certificate2 !== null && Certificate2 !== undefined && Certificate2.length > 0"
                    class="container "
                    dir="ltr">
                <carousel
                        :autoplay="true"
                        :dots="true"
                        :loop="false"
                        :margin="50"
                        :nav="false"
                        :responsive="{0:{items:1,nav:false},500:{items:2,nav:false},1000:{items:3,nav:false}}"
                        :rtl="false">
                    <v-card
                            v-for="item in Certificate2"
                            :key="item.id" class="">
                        <div class="lefttoright">
                            <div class="cursor">
                                <img
                                        :alt="(item.alt)"
                                        :src="getImgUrl(item.src)" class="mx-auto certificate-border"
                                        @click="opencertificate2Dialog(item.srcDialog , item.alt)">
                                <div class="certificate">
                                    <h3 class="font-18 text-center p-3 fontnum bold">
                                        {{ item.name }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </carousel>
            </div>
        </div>

<!--        &lt;!&ndash;کاشانی کیا&ndash;&gt;
        <v-parallax
                height="300"
                class="autumn"
                src="../assets/img/parallax-autumn.jpg"
                :alt="imageSeason.parallaxautumnimage"
        >
            <div class="container-fluid pt-10 ">
                <h2 class="text-center bold pt-5 downtoup secondary-text font-30">
                    {{ $getText("HOME-KASHANI-KIA-TITLE") }}
                </h2>
                <p class="text-center font-16 lefttoright secondary-text ">
                    {{ $getText("HOME-KASHANI-KIA-TEXT") }}
                </p>
                <div class="text-center pb-16 p-4">
                    <router-link to="isokiaKashani">
                        <v-btn
                                color="autumncolor"
                                x-large
                        >
                            &lt;!&ndash;            <i class="fa-solid fa-angle-right pl-5 "></i>&ndash;&gt;
                            {{ $getText("HOME-KASHANI-KIA-BTN") }}
                        </v-btn>
                    </router-link>
                </div>
            </div>
        </v-parallax>-->

        <v-parallax
                height="300"
                class="winter"
                :alt="imageSeason.parallaxwinterimage"
                src="../assets/img/parallax-winter.jpg"
        >
            <div class="container-fluid pt-10 ">
                <h2 class="text-center bold pt-5 downtoup secondary-text font-30">
                    {{ $getText("HOME-KASHANI-KIA-TITLE") }}
                </h2>
                <p class="text-center font-16 lefttoright secondary-text">
                    {{ $getText("HOME-KASHANI-KIA-TEXT") }}
                </p>
                <div class="text-center pb-16 p-4">
                    <router-link to="isokiaKashani">
                        <v-btn
                                class=""
                                color="wintercolor"
                                x-large
                        >
                            <!--            <i class="fa-solid fa-angle-right pl-5 "></i>-->
                            {{ $getText("HOME-KASHANI-KIA-BTN") }}
                        </v-btn>
                    </router-link>
                </div>
            </div>
        </v-parallax>

        <v-parallax
                height="300"
                class="spring"
                :alt="imageSeason.parallaxspringimage"
                src="../assets/img/parallax-spring.jpg"
        >
            <div class="container-fluid pt-10 ">
                <h2 class="text-center bold pt-5 downtoup secondary-text font-30">
                    {{ $getText("HOME-KASHANI-KIA-TITLE") }}
                </h2>
                <p class="text-center font-16 lefttoright secondary-text">
                    {{ $getText("HOME-KASHANI-KIA-TEXT") }}
                </p>
                <div class="text-center pb-16 p-4">
                    <router-link to="isokiaKashani">
                        <v-btn
                                class=""
                                color="springcolor"
                                x-large
                        >
                            <!--            <i class="fa-solid fa-angle-right pl-5 "></i>-->
                            {{ $getText("HOME-KASHANI-KIA-BTN") }}
                        </v-btn>
                    </router-link>
                </div>
            </div>
        </v-parallax>

        <v-parallax
                height="300"
                class="summer"
                :alt="imageSeason.parallaxsummerimage"
                src="../assets/img/parallax-summer.jpg"
        >
            <div class="container-fluid pt-10 ">
                <h2 class="text-center bold pt-5 downtoup secondary-text font-30">
                    {{ $getText("HOME-KASHANI-KIA-TITLE") }}
                </h2>
                <p class="text-center font-16 lefttoright secondary-text">
                    {{ $getText("HOME-KASHANI-KIA-TEXT") }}
                </p>
                <div class="text-center pb-16 p-4">
                    <router-link to="isokiaKashani">
                        <v-btn
                                class=""
                                color="summercolor"
                                x-large
                        >
                            <!--            <i class="fa-solid fa-angle-right pl-5 "></i>-->
                            {{ $getText("HOME-KASHANI-KIA-BTN") }}
                        </v-btn>
                    </router-link>
                </div>
            </div>
        </v-parallax>

        <!--جزییات خدمات-->
        <special-packs></special-packs>

        <!--محصولات-->
        <v-img
                :alt="imageSeason.Background"
                class="autumn"
                height="600"
                src="../assets/img/bg-autumn.jpg"
        >
            <div class="container-fluid ">
                <h2 class="text-center bold downtoup pt-16 white--text font-30">
                    {{ $getText("HOME_PAGE_PRODUCTS_LIST_TITLE") }}
                </h2>
                <p class="text-center font-14 lefttoright white--text">

                </p>
                <div class="">
                    <div class="row mt-4 pb-10">
                        <div class="col-4 col-md-3 col-lg-2 fadeIn mx-auto" v-for="(item,i) in Customers" :key="i">
                            <router-link :to="{path:'AllProductDetail', query:{AllProductID:item.id} }">
                                <img :alt="(item.name)" :src="getImgUrl(item.src)"
                                     class="border-btn img-fluid p-3 light-bg">
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </v-img>

        <v-img
                :alt="imageSeason.Background"
                class="winter"
                height="600"
                src="../assets/img/bg-winter.jpg"
        >
            <div class="container-fluid ">
                <h2 class="text-center bold downtoup pt-16 white--text font-30">
                    {{ $getText("HOME_PAGE_PRODUCTS_LIST_TITLE") }}
                </h2>
                <p class="text-center font-14 lefttoright white--text">

                </p>
                <div class="">
                    <div class="row mt-4 pb-10">
                        <div class="col-4 col-md-3 col-lg-2 fadeIn mx-auto" v-for="(item,i) in Customers" :key="i">
                            <router-link :to="{path:'AllProductDetail', query:{AllProductID:item.id} }">
                                <img :alt="(item.name)" :src="getImgUrl(item.src)"
                                     class=" border-btn img-fluid p-3 light-bg">
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </v-img>

        <v-img
                :alt="imageSeason.Background"
                class="spring"
                height="620"
                src="../assets/img/bg-spring.jpg"
        >
            <div class="container-fluid ">
                <h2 class="text-center bold downtoup pt-16 white--text font-30">
                    {{ $getText("HOME_PAGE_PRODUCTS_LIST_TITLE") }}
                </h2>
                <p class="text-center font-14 lefttoright white--text">

                </p>
                <div class="">
                    <div class="row mt-4 pb-10">
                        <div class="col-4 col-md-3 col-lg-2 fadeIn mx-auto" v-for="(item,i) in Customers" :key="i">
                            <router-link :to="{path:'AllProductDetail', query:{AllProductID:item.id} }">
                                <img :alt="(item.name)" :src="getImgUrl(item.src)"
                                     class="border-btn img-fluid p-3 light-bg">
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </v-img>

        <v-img
                :alt="imageSeason.Background"
                class="summer"
                height="600"
                src="../assets/img/bg-summer.jpg"
        >
            <div class="container-fluid ">
                <h2 class="text-center bold downtoup pt-16 white--text font-30">
                    {{ $getText("HOME_PAGE_PRODUCTS_LIST_TITLE") }}
                </h2>
                <p class="text-center font-14 lefttoright white--text">

                </p>
                <div class="">
                    <div class="row mt-4 pb-10">
                        <div class="col-4 col-md-3 col-lg-2 fadeIn mx-auto" v-for="(item,i) in Customers" :key="i">
                            <router-link :to="{path:'AllProductDetail', query:{AllProductID:item.id} }">
                                <img :alt="(item.name)" :src="getImgUrl(item.src)"
                                     class=" border-btn img-fluid p-3 light-bg">
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </v-img>

        <!--مزایای -->
        <div class="container-fluid pt-10 light-bg">
            <div class="text-center secondary-text font-28 uptodown">
                <i class="fa-light fa-thumbs-up font-60"></i>
            </div>
            <h2 class="text-center bold pt-5 downtoup secondary-text font-30">
                {{ $getText("HOME_PAGE_BENEFITS_LIST_TITLE") }}
            </h2>
            <p class="text-center secondary-text font-12 lefttoright">
                {{ $getText("HOME_PAGE_BENEFITS_LIST_DESC") }}
            </p>
            <div
                    v-if="benefits !== null && benefits !== undefined && benefits.length > 0"
                    class="mx-4 lefttoright"
                    dir="ltr">
                <carousel
                        :autoplay="true"
                        :dots="true"
                        :loop="false"
                        :nav="false"
                        :margin="30"
                        :responsive="{0:{items:1,nav:false},500:{items:2,nav:false},1000:{items:3,nav:false}}"
                >
                    <div class=""
                         v-for="(item,i) in benefits" :key="i">
                        <div class="rounded Customers-card-height white">
                            <div class="profile-box" id="Customerscard">
                                <h3 class="mt-12 mx-8 mb-10 pt-10 font-18 bold">
                                    {{ item.title }}
                                </h3>
                            </div>
                            <div class="card-body text-center text-over-flow-benefits">
                                <p class="">
                                    {{ item.text }}
                                </p>
                            </div>
                        </div>
                    </div>
                </carousel>
            </div>
        </div>

        <!--  سوال های متدوال  -->
        <div class="container-fluid py-8 ">
            <div class="text-center font-28 uptodown">
                <i class="fa-solid fa-messages-question font-60 secondary-text"></i>
            </div>
            <h2 class=" text-center bold pt-5 uptodown secondary-text font-30">
                سوالات متداول
            </h2>
            <div class="container" id="expansion">
                <v-expansion-panels>
                    <v-expansion-panel
                            v-for="(item,i) in expansion" :key="i"
                    >
                        <v-expansion-panel-header expand-icon="mdi-menu-down" class="light-bg font-18">
                            {{ item.header }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="text-align mt-6">{{ item.title }}</v-expansion-panel-content>
                        <v-expansion-panel-content class="text-align ">{{ item.title2 }}</v-expansion-panel-content>
                        <v-expansion-panel-content class="text-align ">{{ item.title3 }}</v-expansion-panel-content>
                        <v-expansion-panel-content class="text-align ">{{ item.title4 }}</v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>

        <!--کلاس ها-->
        <div class="container-fluid py-16 light-bg">
            <div class="text-center secondary-text font-28 pt-5 uptodown ">
                <i class="fa-solid fa-person-chalkboard font-60"></i>
            </div>
            <h2 class="text-center secondary-text bold pt-5 downtoup font-30">
                کلاس های آموزشی
            </h2>
            <p class="text-center  font-12 lefttoright">

            </p>
            <div
                    v-if="Articles !== null && Articles !== undefined && Articles.length > 0"
                    class="container--fluid mx-4 righttoleft"
                    dir="ltr">
                <carousel
                        :autoplay="true"
                        :dots="true"
                        :loop="false"
                        :nav="false"
                        :margin="30"
                        :responsive="{0:{items:1,nav:false},500:{items:2,nav:false},1000:{items:3,nav:false}}"
                        :rtl="true">
                    <div class="" v-for="(item,i) in Articles" :key="i">
                        <div class="rounded white">
                            <div class="container p-4 ">
                                <img class="light-bg"

                                     :src="getImgUrl(item.src)"
                                     :alt="item.title">
                            </div>
                            <p class="text-center font-14 bold">

                            </p>
                            <h4 class="text-center secondary-text bold">
                                {{ item.title }}
                            </h4>
                            <div class="card-text card-body text-left">
                                <p class="mx-5 card-title">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div class="container">
                                <div class="text-center">
                                </div>
                            </div>
                        </div>
                    </div>
                </carousel>
            </div>
        </div>

        <footer-pages></footer-pages>

        <!--back to iop-->
        <v-btn @click="top()" id="myBtn" class="secondary-bg  gototop hvr-bob  "
               icon
               large
        >
            <i class="fal fa-chevron-double-up white--text "></i>
        </v-btn>

        <v-dialog
                v-model="certificateDialog"
                width="800">
            <v-card class="text-center">
                <img :src="certificateImage" class="img-fluid" :alt="certificateAlt">
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="certificate2Dialog"
                width="500">
            <v-card class="text-center">
                <img :src="certificateImage" class="img-fluid" :alt="certificateAlt">
            </v-card>
        </v-dialog>
        <!--    <tes-t></tes-t>-->

    </div>
</template>

<script>


let _this = null;
import FooterPages from "@/components/FooterPages";
import NavBar from "@/components/NavBar";
import carousel from "vue-owl-carousel";
import CardSlide from "@/components/CardSlide";
import ServiceCard from "@/components/ServiceCard";
/*import VueJsCounter from 'vue-js-counter'*/
import SpecialPacks from "@/components/SpecialPacks";
// import TesT from "@/components/TesT";
import $ from 'jquery'

export default {
    name: "HomePage",
    metaInfo: {
        title: 'ایزیسیس طراحی وب سایت اپلیکیشن موبایل و استارت اپ-خانه'
    },

    components: {carousel, SpecialPacks, CardSlide, NavBar, ServiceCard, FooterPages},
    data: () => ({
        certificateImage: null,
        certificateAlt: null,
        certificateDialog: false,
        certificate2Dialog: false,
        bannerwinter: [],
        bannerfall: [],
        bannerspring: [],
        bannersummer: [],
        Certificate: [
            {
                id: 1,
                src: "Iravani-MBA.jpg",
                name: "MBA Certificate",
                alt: "MBA Certificate",
                srcDialog: require('../assets/img/Iravani-MBA.jpg'),
            },
            {
                id: 2,
                src: "Iravani-DBA.jpg",
                name: "DBA Certificate",
                alt: "DBA Certificate",
                srcDialog: require('../assets/img/Iravani-DBA.jpg'),

            },
            {
                id: 3,
                src: "Amani-MBA.jpg",
                name: "MBA Certificate",
                alt: "MBA Certificate",
                srcDialog: require('../assets/img/Amani-MBA.jpg'),

            },
            {
                id: 4,
                src: "Amani-DBA.jpg",
                name: "DBA Certificate",
                alt: "DBA Certificate",
                srcDialog: require('../assets/img/Amani-DBA.jpg'),

            },

            {
                id: 5,
                src: "IZISYS.jpg",
                name: "Informatic Society of Iran",
                alt: "Informatic Society of Iran",
                srcDialog: require('../assets/img/IZISYS.jpg'),

            },
        ],
        Certificate2: [
            {
                id: 1,
                src: "ISO9001-2015.jpg",
                name: "ISO 9001:2015",
                alt: "ISO 9001:2015",
                srcDialog: require('../assets/img/ISO9001-2015.jpg'),


            },
            {
                id: 2,
                src: "Amani-Teacher-Certificate.jpg",
                name: "Teacher Certificate",
                alt: "Teacher-Certificate",
                srcDialog: require('../assets/img/Amani-Teacher-Certificate.jpg'),

            },
            {
                id: 3,
                src: "Iravani-Teacher-Certificate.jpg",
                name: "Teacher Certificate",
                alt: "Teacher-Certificate",
                srcDialog: require('../assets/img/Iravani-Teacher-Certificate.jpg'),

            },

        ],
        Customers: [
            {
                id: "12",
                src: 'MashinSazanAslanian.png',
                name: "MashinSazanAslanian"
            },
            {
                id: "14",
                src: 'new3dlogo.png',
                name: "Eyvankhaneh"

            },
            {
                id: "1",
                src: 'eyvankhaneh-2.png',
                name: "Eyvankhaneh"

            },
            {
                id: "13",
                src: 'MasireBartar.png',
                name: "MasireBartar"
            },
            {
                id: "11",
                src: 'OstadeMan.png',
                name: "OstadeMan"

            },
            {
                id: "8",
                src: 'KharidAbzar.png',
                name: "KharidAbzar"
            },
            {
                id: "4",
                src: 'Ketrak.png',
                name: "OstadeMan"
            },
            {
                id: "6",
                src: 'Mojava.png',
                name: "Ketrak"
            },
            {
                id: "10",
                src: 'Carpiin.png',
                name: "Carpiin"
            },

            {
                id: "3",
                src: 'HafezMobile.png',
                name: "HafezMobile"
            },
            {
                id: "15",
                src: 'MobleMisagh.png',
                name: "MobleMisagh"
            },
            /*    {
                  id: "11",
                  src: 'Isokia.png',
       name:"Isokia"
                },*/
            {
                id: "2",
                src: 'TaminBaMa.png',
                name: "TaminBaMa"
            },
        ],
        Articles: [
            {
                id: '1',
                src: 'html.logo.png',
                title: "HTML",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '2',
                src: 'css.logo.png',
                title: "CSS",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '3',
                src: 'js.logo.png',
                title: "JavaScript",
                text: "",
                btn: "بیشتر",

            },

            {
                id: '4',
                src: 'jquery.logo.png',
                title: "jQuery",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '5',
                src: 'vuejs.logo.png',
                title: "Vue.js",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '6',
                src: 'reactjs.logo.png',
                title: "React.js",
                text: "",
                btn: "بیشتر",

            },

            {
                id: '9',
                src: 'reactnative.logo.png',
                title: "asp.net Core",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '7',
                src: 'csharp.logo.png',
                title: "C# مقدماتی و پیشرفته",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '8',
                src: 'aspdotnet.png',
                title: "asp.net Core",
                text: "",
                btn: "بیشتر",

            },
            {
                id: '10',
                src: 'dotnet.logo.png',
                title: ".net Core",
                text: "",
                btn: "بیشتر",

            },

        ],
        benefits: [],
        expansion: [],
        imageSeason: {},
    }),
    mounted() {
        _this = this
        this.$setCssFiles();
        this.$getLanguage();
        this.$changeRTL();
        this.imageSeason = this.$getimageSeason();
        this.benefits = this.$getBenefits();
        this.expansion = this.$getexpansion();
        this.bannerwinter = this.$getbannerwinter();
        this.bannerfall = this.$getbannerfall();
        this.bannerspring = this.$getbannerspring();
        this.bannersummer = this.$getbannersummer();
        $(window).on("load scroll", function () {
            _this.reveal($('.righttoleft'), $(this));
            _this.reveal($('.uptodown'), $(this));
            _this.reveal($('.downtoup'), $(this));
            _this.reveal($('.lefttoright'), $(this));
            _this.reveal($('.fadeIn'), $(this));
        });
    },
    methods: {
        openCertificateDialog(srcDialog, alt) {
            this.certificateDialog = true
            this.certificateImage = srcDialog
            this.certificateAlt = alt
        },
        opencertificate2Dialog(srcDialog, alt) {
            this.certificate2Dialog = true
            this.certificateImage = srcDialog
            this.certificateAlt = alt
        },
        top() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        reveal(item, wrapper) {
            var verticalEdge = wrapper.scrollTop() + wrapper.outerHeight(),
                horizontalEdge = wrapper.scrollLeft() + wrapper.outerWidth();
            item.each(function () {
                if ((verticalEdge >= $(this).offset().top) &&
                    (horizontalEdge >= $(this).offset().left)) {
                    $(this).addClass('animate');
                }
            });
        },
        getImgUrl(pic) {
            return require("../assets/img/" + pic);
        }
    },
}

</script>

<style scoped>

</style>
